<footer class="section-footer bg-secondary">
    <div class="container">
        <section class="footer-top padding-y-lg text-white">
            <div class="row">
                <aside class="col-md col-6">
                    <h6 class="title">{{'FOOTER.BRANDS' | translate}}</h6>
                    <ul class="list-unstyled">
                        <li> <a href="#">Adidas</a></li>
                        <li> <a href="#">Puma</a></li>
                        <li> <a href="#">Reebok</a></li>
                        <li> <a href="#">Nike</a></li>
                    </ul>
                </aside>
                <aside class="col-md col-6">
                    <h6 class="title">{{'FOOTER.COMPANY' | translate}}</h6>
                    <ul class="list-unstyled">
                        <li> <a href="#">{{'FOOTER.ABOUTUS' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.CAREER' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.FINDASTORE' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.RULESANDTERMS' | translate}}</a></li>
                    </ul>
                </aside>
                <aside class="col-md col-6">
                    <h6 class="title">Help</h6>
                    <ul class="list-unstyled">
                        <li> <a href="#">{{'FOOTER.CONTACTUS' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.MONEYREFUND' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.ORDERSTATUS' | translate}}</a></li>
                        <li> <a href="#">{{'FOOTER.SHIPPINGINFO' | translate}}</a></li>
                    </ul>
                </aside>
                <aside class="col-md col-6">
                    <h6 class="title">{{'FOOTER.ACCOUNT' | translate}}</h6>
                    <ul class="list-unstyled">
                        <li> <a href="#"> {{'FOOTER.USERLOGIN' | translate}} </a></li>
                        <li> <a href="#"> {{'FOOTER.USERREGISTER' | translate}} </a></li>
                        <li> <a href="#"> {{'FOOTER.ACCOUNTSETTINGS' | translate}} </a></li>
                        <li> <a href="#"> {{'FOOTER.MYORDERS' | translate}} </a></li>
                    </ul>
                </aside>
                <aside class="col-md">
                    <h6 class="title">{{'FOOTER.SOCIAL' | translate}}</h6>
                    <ul class="list-unstyled">
                        <li><a href="#"> <i class="fa fa-facebook"></i> Facebook </a></li>
                        <li><a href="#"> <i class="fa fa-twitter"></i> Twitter </a></li>
                        <li><a href="#"> <i class="fa fa-instagram"></i> Instagram </a></li>
                        <li><a href="#"> <i class="fa fa-youtube"></i> Youtube </a></li>
                    </ul>
                </aside>
            </div> <!-- row.// -->
        </section>  <!-- footer-top.// -->

        <section class="footer-bottom text-center">
        
               
                <p class="text-muted"> &copy; {{'FOOTER.BOTTOM' | translate}} </p>
        </section>
    </div><!-- //container -->
</footer>